"use strict";
import * as dom from "./lib/dom.js";
import { tns } from "tiny-slider";

export default function () {
    const slide = document.querySelector(".podcast-slider_container");
    if (slide) {
        const QsSlide = tns({
            container: ".podcast-slider_container",
            loop: true,
            items: 1,
            slideBy: "page",
            controls: false,
            navPosition: "bottom",
            touch: true,
            mouseDrag: true,
            gutter: 12,
            center: true,
        });
        const arrow_left = document.querySelector(
            ".podcast-slider_holder .arrow-left"
        );
        arrow_left.addEventListener("click", () => {
            QsSlide.goTo("prev");
        });
        const arrow_right = document.querySelector(
            ".podcast-slider_holder .arrow-right"
        );
        arrow_right.addEventListener("click", () => {
            QsSlide.goTo("next");
        });
    }
}
